import { h, render, Component, Fragment } from 'preact';
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { StateProvider } from "../store.js";

import Header from "../components/Header";
import Footer from "../components/Footer";
import ScrollToTop from "../components/scrollTop";
import Homepage from "../pages/homepage";
import CarListPage from "../pages/carlistpage";
import CardDetailsPage from "../pages/cardDetailsPage";

window.React = require('preact');

class App extends Component {
    render() {
        return (
            <StateProvider>
                <BrowserRouter>
                    <Fragment>
                        <ScrollToTop />
                        <Header />
                        <Switch>
                            <Route exact path="/" component={Homepage} />
                            <Route
                                exact
                                path="/lista-carros-usados-stand-pombal"
                                component={CarListPage}
                            />
                            <Route
                                path="/lista-carros-usados-stand-pombal/:query"
                                component={CardDetailsPage}
                            />
                            <Redirect to="/" />
                        </Switch>
                        <Footer />
                    </Fragment>
                </BrowserRouter>
            </StateProvider>
        );
    }
}

render(<App />, document.getElementById("app"));
